import { Injectable } from '@angular/core';
import { ApiClientService, ApiResponse } from './api-client.service';
import { HttpClient } from '@angular/common/http';
import { AB_API_PORTFOLIO_DEFAULT } from '../constants';
import { ReplaySubject, Observable } from 'rxjs';

export interface DefaultPortfolioResponse extends ApiResponse {
  portfolioNumber: string;
}

@Injectable({
  providedIn: 'root'
})
export class DefaultPortfolioService extends ApiClientService {
  private defaultPortfolio: DefaultPortfolioResponse;
  private portfolio = new ReplaySubject<DefaultPortfolioResponse>();

  private isLoading = false;

  constructor(http: HttpClient) {
    super(http, AB_API_PORTFOLIO_DEFAULT);
  }

  clearDefaultPortfolio() {
    this.defaultPortfolio = undefined;
  }

  getPortfolio() {
    if (this.defaultPortfolio) {
      return this.portfolio.asObservable();
    }

    if (!this.isLoading && !this.defaultPortfolio) {
      this.isLoading = true;
      this.get().subscribe(
        res => {
          this.isLoading = false;
          this.defaultPortfolio = res;
          this.portfolio.next({ ...this.defaultPortfolio });
        },
        error => {
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        }
      );
    }

    return this.portfolio.asObservable();
  }

  setDefaultPortfolio(portfolioId: string) {
    this.defaultPortfolio = {
      ...this.defaultPortfolio,
      portfolioNumber: portfolioId
    };
    this.portfolio.next({ ...this.defaultPortfolio });
  }

  setPortfolio(portfolios: any): Observable<ApiResponse> {
    return this.postWithButtonLoader({ portfolios: portfolios });
  }
}
